import { render, staticRenderFns } from "./AyudaSection.vue?vue&type=template&id=3a5ff430&scoped=true"
import script from "./AyudaSection.vue?vue&type=script&lang=js"
export * from "./AyudaSection.vue?vue&type=script&lang=js"
import style0 from "./AyudaSection.vue?vue&type=style&index=0&id=3a5ff430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ff430",
  null
  
)

export default component.exports